import React from 'react'
import InterestModal from '..'
import Overlay from '../overlay'
import { AnimatePresence } from 'framer-motion';
import { useModalStore } from '@/store/modal/store';
import { useTranslation } from 'react-i18next';

function WelcomeModal() {
  const { t } = useTranslation();
  const { modal, setModal } = useModalStore();

  return (
    <AnimatePresence>
      {modal.welcome && (
        <Overlay close={() => setModal({ welcome: false })}>
          <InterestModal>
            <div className="general-modal" style={{ maxWidth: '500px' }}>
              <div className="general-modal__header">
                {t("welcome.welcome_modal_title")}
              </div>
              <div className="general-modal__content">
                {t("welcome.welcome_modal_content")}
              </div>
              <div className="general-modal__footer">
                <button className={'cta-button cta-blue cta-medium'} onClick={() => setModal({ welcome: false })}>
                  {t("common.close")}
                </button>
              </div>
            </div>
          </InterestModal>
        </Overlay>
      )}
    </AnimatePresence>
  )
}

export default WelcomeModal
